import { createStyles, makeStyles, Theme } from "@material-ui/core";

interface MapOverlayControlStylesProps {
    expanded?: boolean;
}

export const mapOverlaysControlStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            right: 10,
            top: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
        },

        button: {
            display: "flex",
            alignItems: "center",
            padding: "7px 12px",
            background: theme.colors.neutrals.neutral100,
            borderRadius: theme.shape.borderRadius,
            color: theme.colors.neutrals.neutral600,
            border: "1px solid",
            borderColor: ({ expanded }: MapOverlayControlStylesProps) =>
                expanded
                    ? theme.colors.primary.blue400
                    : theme.colors.neutrals.neutral200,

            "& svg": {
                width: 9,
                marginLeft: 5,
                fill: ({ expanded }: MapOverlayControlStylesProps) =>
                    expanded
                        ? theme.colors.primary.blue400
                        : theme.colors.neutrals.neutral500,
            },

            "&:hover": {
                backgroundColor: "#F8F8F8 !important",
            },
        },

        list: {
            marginTop: "10px",
            background: theme.colors.neutrals.white,
            borderRadius: "3px",
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            width: "170px",
        },

        itemRoot: {
            "&:hover": {
                background: theme.colors.primary.blue75,
            },

            ...theme.typography.body1,
            color: theme.colors.neutrals.neutral500,
            display: "flex",
            alignItems: "center",
        },
    })
);
